"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ThreeKindsOfBuyers() {
  const {
    ref: introRef,
    isVisible: introVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const pillars = [{
    numeral: "I",
    name: "Compliance",
    body: "We operate strictly within industry standards. Every legend plate, arc flash label, and asset tag is produced to meet your specific regulatory requirements and project specifications.",
    image: {
      src: "https://evermarkindustrial.com/wp-content/uploads/2026/06/Phenolic_Labels-scaled.jpg?v=v72aivvdwnc",
      srcset: "https://evermarkindustrial.com/wp-content/uploads/2026/06/Phenolic_Labels-scaled.jpg?v=u2zto7lzek-wvc-srcset",
      sizes: "https://evermarkindustrial.com/wp-content/uploads/2026/06/Phenolic_Labels-scaled.jpg?v=c85zoei7cue-wvc-sizes",
      alt: "Precision laser marked industrial compliance tag"
    },
    alignment: "justify-start"
  }, {
    numeral: "II",
    name: "Permanence",
    body: "Identification must outlast the environment. We utilize high-grade stainless steel, brass, and phenolic materials to ensure your markings remain legible in the most demanding industrial conditions.",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/dpm_verification_chart.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/dpm_verification_chart.png",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/dpm_verification_chart.png",
      alt: "Durable engraved metal asset tag detail"
    },
    alignment: "justify-center"
  }, {
    numeral: "III",
    name: "Precision",
    body: "Technical accuracy is our baseline. We process your files and part lists with engineering-grade precision, ensuring every character is placed exactly where it is specified.",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_precision_detail.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_precision_detail.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_precision_detail.png-wvc-sizes",
      alt: "Close up of high precision laser engraving"
    },
    alignment: "justify-end"
  }];
  return <section data-section-id="211" id="three-kinds-of-buyers" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32 lg:py-[180px] px-6 md:px-10">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.05] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\")"
    }} />

      <div className="relative mx-auto max-w-[1280px]">
        {}
        <div ref={introRef} className={`mx-auto max-w-3xl text-center transition-all duration-1000 ease-out ${introVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-default text-xs tracking-[0.35em] uppercase" style={{
          color: "var(--chart-1)"
        }}>
            The Evermark Standard — 
          </p>
          <h2 className="font-default font-bold text-foreground mt-8 text-4xl sm:text-5xl md:text-6xl lg:text-[64px] leading-[1.05] tracking-tight">
            Three principles guide every{" "}
            <em className="italic font-light" style={{
            color: "var(--chart-1)"
          }}>
              mark
            </em>
            .
          </h2>
        </div>

        {}
        <div className="mt-24 md:mt-32 grid grid-cols-1 md:grid-cols-3 gap-16 md:gap-12 lg:gap-20">
          {pillars.map((pillar, i) => {
          const {
            ref,
            isVisible
          } = useRevealOnScroll<HTMLDivElement>({
            threshold: 0.15
          });
          return <div key={pillar.name} data-index={i} ref={ref} className={`flex flex-col transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                {}
                <div className="font-default font-bold text-[80px] leading-none" style={{
              color: "transparent",
              WebkitTextStroke: "1px var(--chart-1)"
            }} aria-hidden="true">
                  {pillar.numeral}
                </div>

                {}
                <h3 className="font-default font-bold text-foreground mt-8 text-3xl md:text-[36px] leading-tight">
                  {pillar.name}
                </h3>

                {}
                <div className="mt-6 h-px w-10" style={{
              backgroundColor: "var(--chart-1)"
            }} aria-hidden="true" />

                {}
                <p className="font-default mt-6 text-[17px] leading-[1.75] max-w-sm" style={{
              color: "var(--foreground)",
              opacity: 0.85
            }}>
                  {pillar.body}
                </p>

                {}
                <div className={`mt-12 flex ${pillar.alignment}`}>
                  <div className="w-[220px] md:w-[240px] lg:w-[280px] overflow-hidden rounded-lg">
                    <div className="relative" style={{
                  aspectRatio: "4 / 5"
                }}>
                      <img src={pillar.image.src} data-wvc-srcset={pillar.image.srcset} data-wvc-sizes={pillar.image.sizes} alt={pillar.image.alt} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover transition-[filter,transform] duration-[1200ms] ease-out hover:brightness-110 hover:scale-[1.02]" style={{
                    filter: "brightness(0.92)"
                  }} />
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}